<!--直播间管理：选择工作单位-单选 -->
<template>
  <el-dialog
    class="rc-dialog"
    title="选择工作单位"
    :visible.sync="showModal.flag"
    width="40%"
    :close-on-click-modal="false"
    :destroy-on-close="false"
  >
    <el-input
      class="search-dept"
      size="small"
      v-model.trim="deptName"
      @change="searchDep"
      placeholder="请输入部门名称"
      prefix-icon="el-icon-search"
    />
    <el-tree
      lazy
      class="dept-tree"
      :data="treeData"
      :props="props"
      show-checkbox
      check-strictly
      :expand-on-click-node="false"
      check-on-click-node
      :default-expanded-keys="defaultExpandKey"
      :default-checked-keys="defaultCheckedKeys"
      node-key="uuid"
      @check="handleCheck"
      ref="deptTree"
      :load="loadNode"
    >
      <span  class="custom-tree-node" slot-scope="{ node, data }">
        <template v-if="showTooltip">
          <el-tooltip v-if="isSearch" class="item" effect="dark" :content="data.fullName" placement="top-start">
            <span class="ellipsis--l1">{{ data.simpleName || node.label }}</span>
          </el-tooltip>
          <el-tooltip v-else class="item" effect="dark" :content="node.label" placement="top-start">
            <span class="ellipsis--l1">{{ node.label }}</span>
          </el-tooltip>
        </template>
        <span v-else class="ellipsis--l1">{{ node.label }}</span>
      </span>
    </el-tree>
    <span slot="footer" class="dialog-footer">
      <el-button @click="showModal.flag = false" size="small">取 消</el-button>
      <el-button type="primary" @click="selectDept" size="small"
        >确 定</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
import { deptTreeForClass } from "@/api/dept";
export default {
  props: {
    showModal: {
      type: Object,
      default: () => {
        return {
          flag: false,
        };
      },
    },
    showTooltip: {
      type: Boolean,
      default: false,
    },
    defaultCheckedKeys: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      props: {
        label: "deptName",
        children: "zones",
        isLeaf: function(data, node) {
          return !data.hasChildren
        }
      },
      defaultExpandKey: [],
      deptName: "",
      treeData: [],
      isSearch: false,
    };
  },
  methods: {
    // 加载节点
    loadNode(node, resolve) {
      let params = {
        parentId: node.data && node.data.uuid || "",
        bNotAcrossDept: 1
      }
      deptTreeForClass(params).then(({ code, data }) => {
        if (code !== 0) return;
        let treeData = this.dealSourceData(data);
        resolve(treeData);
      });
    },
    // 搜索
    searchDep() {
      this.treeData = [];
      let params = {
        deptName: this.deptName,
        bNotAcrossDept: 1
      }
      this.isSearch = this.deptName && this.deptName.length > 0;
      deptTreeForClass(params).then(({ code, data }) => {
        if (code !== 0) return;
        this.treeData = this.dealSourceData(data);
      });
    },
    dealSourceData(arr) {
      if (!Array.isArray(arr)) return;
      return arr.map((x, i) => {
        return {
          ...x,
          // disabled: x.hasChildren,
        };
      });
    },
    // 选择部门
    selectDept() {
      const checkedNodes = this.$refs["deptTree"].getCheckedNodes();
      this.$emit("deptSelected", checkedNodes[0]);
    },
    // tree单选
    handleCheck(data) {
      this.$refs["deptTree"].setCheckedKeys([data.uuid]);
    },
  },
};
</script>

<style lang="scss" scoped>
.search-dept {
  margin-bottom: 8px !important;
}
.dialog {
  /deep/ .el-dialog__body {
    max-height: 400px;
    overflow: hidden;
  }
  .dept-tree {
    width: 60%;
    max-height: 300px;
    overflow-y: auto;
  }
}
</style>
